require("./snippets/accordion");
require("./snippets/product-quick-view-modal");
require("./qf/global_listeners");
//require("./qf/wishlist");
require("./qf/cart");
require("./qf/ModalController");
import { Lightbox } from './qf/lightbox';

window.modalController = new ModalController()
//window.wishlist = new WishlistQf();
window.globalListeners = new GlobalListeners();
window.Lightbox = Lightbox;
window.cart = new CartQf();
